<script setup>
import { ref, watch, defineEmits } from "vue";
import stores from "../stores";
const dpts = stores.useDepartmentStore();

const props = defineProps({
  unselectedLabel: { type: String, default: "Department" },
  dptId: { type: String, default: "nodpt" },
  organizationId: { type: String, default: "noorg" },
  disabled: { type: Boolean, default: false },
  paddingSize: { type: String, default: "normal"},
});

const emit = defineEmits(["updated"]);

const selected = ref(props.dptId);

// sync prop → local state
watch(
  () => props.dptId,
  (val) => {
    selected.value = val;
  }
);

// emit ONLY when the user changes selection
const onSelect = (newVal) => {
  emit("updated", newVal);
};

const options = dpts.dropdownOptions;
</script>

<template>
  <dropdown
    class="department-dropdown"
    header="Assigned Department"
    v-model="selected"
    @update:modelValue="onSelect"
    :disabled="disabled"
    :label="dpts.allDict[selected]?.name || unselectedLabel"
    :options="options"
    :padding-size="paddingSize"
  />
</template>

<style lang="scss" scoped>
.department-dropdown {
  width: 100px;
  :deep(button) {
    width: 100%;
    > span {
      width: 100%;
      > span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
      }
    }
  }
}
.dropdown {
  :deep(.dropdown-toggle) {
    border: none;
    background: none;
    &:active,
    &:hover,
    &:focus {
      border: none;
    }
  }
  :deep(.btn) {
    .label {
      font-size: $font-size-xs;
    }
  }
}
:deep {
  .dropdown-menu {
    width: 200px;
  }
}
</style>
